import React from 'react'
import { useLocalWindowLayout } from '../api/useLocalWindowLayout'
import EmptyState from '../components/EmptyState'
import { ProviderRoleId } from '../currentRole'
import AddComponentTile from './AddComponentTile'
import DashboardCanvas from './DashboardCanvas'
import DashboardGrid, { GridItem } from './DashboardGrid'
import DashboardRenderer from './DashboardRenderer'
import { PanelCategory, PanelOfferScope } from './registry'

type Props = {
  uid: string
  windowId: string
  role: ProviderRoleId
  editMode: boolean
  onlyCategories?: PanelCategory[]
}

const WindowEditor = ({ uid, windowId, role, editMode, onlyCategories }: Props) => {
  const { layout, controls } = useLocalWindowLayout(windowId, role)
  const isEmpty = layout.panels.length === 0
  const scope: PanelOfferScope = { onlyCategories, excludeProgramPanels: true }

  return (
    <DashboardCanvas>
      {!isEmpty && (
        <DashboardRenderer uid={uid} layout={layout} controls={editMode ? controls : undefined} scope={scope} />
      )}

      {isEmpty && !editMode && <EmptyState title="Nothing here yet" />}

      {editMode && (
        <DashboardGrid>
          <GridItem span="full">
            <AddComponentTile uid={uid} layout={layout} onAdd={controls.add} prominent={isEmpty} scope={scope} />
          </GridItem>
        </DashboardGrid>
      )}
    </DashboardCanvas>
  )
}

export default WindowEditor
